(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name subjectController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('subjectController', subjectController);

    subjectController.$inject = ["subjectService","$window","$timeout","$location"];

    function subjectController(subjectService,$window,$timeout,$location)
    {
    	var vm = this;
        vm.subject = subjectService;
        vm.data = {};
        vm.data.etiquetas = {};
        vm.loading = false;
        vm.subjects=[];
        vm.offset=0;
        vm.curso_id = "";
        vm.loading_images = false;
        vm.loading_files = false;
        vm.option = 'id desc';

        vm.filters = {numero:[],trim:[],tipo:[]};

        vm.orden = { ordenparam : false, nombre:'nombre' };

        vm.toggleNumero = function(item){
            var idx = vm.filters.numero.indexOf(item.id);

            // Is currently selected
            if (idx > -1) {
              vm.filters.numero.splice(idx, 1);
            }else {
              vm.filters.numero.push(item.id);
            }
            console.log(vm.filters);
            //vm.getSubjects(vm.curso_id);
        }
        vm.toggleTrim = function(item){
            var idx = vm.filters.trim.indexOf(item.id);

            // Is currently selected
            if (idx > -1) {
              vm.filters.trim.splice(idx, 1);
            }else {
              vm.filters.trim.push(item.id);
            }
            console.log(vm.filters);
            //vm.getSubjects(vm.curso_id);
        }
        vm.toggleTipo = function(item){
            var idx = vm.filters.tipo.indexOf(item.id);

            // Is currently selected
            if (idx > -1) {
              vm.filters.tipo.splice(idx, 1);
            }else {
              vm.filters.tipo.push(item.id);
            }
            console.log(vm.filters);
            //vm.getSubjects(vm.curso_id);
        }

        vm.cambiarOrden = function(nombre){
            if(nombre==vm.orden.nombre){
                //console.log("IGUAL");
                //console.log("IGUAL");
                if(vm.orden.ordenparam == false){
                    vm.orden.ordenparam = true;
                }else{
                    vm.orden.ordenparam = false;
                }
            }else{
                vm.orden.ordenparam = false;
            }
            vm.orden.nombre = nombre;
            //vm.orden.fin_nombre = vm.orden.ordenparam+nombre;
            //console.log(vm.orden);
        }

        vm.resetSubjects = function()
        {
            vm.offset=0;
            vm.subjects=[];
            vm.loading = false;
            //vm.search = "";
        };


        vm.existArray = function(array1,array2){
            for(var cont=0;cont<array1.length;cont++){
                for(var cont2=0;cont2<array2.length;cont2++){
                    if(array1[cont]==array2[cont2]){
                        return true;
                    }
                }
            }
            return false;
        }
        vm.filterAsigs = function(item){

            if(vm.filters.numero.length==0 && vm.filters.trim.length == 0 && vm.filters.tipo.length ==0){
                return true;
            }else{
                var existeTrim = (vm.filters.trim.length== 0 ? true : vm.existArray(vm.filters.trim,item.trimestres_ids));
                var existeCur = (vm.filters.numero.length== 0 ? true : vm.existArray(vm.filters.numero,item.numerocurso_id));
                var existeTipo = (vm.filters.tipo.length== 0 ? true : vm.existArray(vm.filters.tipo,item.tipoasignatura_id));
                if(existeTrim && existeCur && existeTipo){
                    return true;
                }else{
                    return false;
                }
            }
        }

        vm.getSubjects = function(curso_id)
        {
            vm.curso_id = curso_id;
            if(vm.loading)
                return;

            vm.loading = true;

            vm.subject.getSubjects(curso_id,vm.offset,vm.option).then(function(data)
            {
                    vm.data = data;
                /*if(vm.subjects.length==0){
                    vm.data = data;
                }*/
                vm.subjects = data.asignaturas;
                vm.loading =false;
                if(data.length){
                    vm.offset++;    
                    vm.subjects = vm.subjects.concat(data.asignaturas);
                }
                setTimeout(function(){ 
                    console.log('a');
                    $('.table-orders .collapse').on('shown.bs.collapse', function () {
                      var $scrollEl = $(this).closest('.card');
                      var $scrollWTo = $scrollEl.offset().top;
                      $('body, html').animate({ scrollTop: $scrollWTo - 80 }, 500);
                    });
                }, 100);
            });
        };

    }


})();